import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import {
  makeStyles,
} from "@material-ui/core";
import { Link, Link as RouterLink } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PersonIcon from '@material-ui/icons/Person';
import Hidden from '@material-ui/core/Hidden';
import CloseIcon from '@material-ui/icons/Close';
import { useCookies } from 'react-cookie';


const Container = styled.div`
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0;
  background: black;
  color: #FFFFFF;
  z-index: 1;
`;

const useStylesAll = makeStyles(theme => ({
  logo: {
    height: "36px",
    margin: "7px 10px",
    marginLeft: "10px",
    [theme.breakpoints.up('xs')]: {
      marginLeft: "30px",
    },
  },
  item: {
    lineHeight: "50px",
    verticalAlign: "middle",
    display: "inline-grid",
    textDecoration: "none",
    color: "#FFFFFF",
    '&:hover': {
      color: "#962013",
      cursor: "pointer",
    },
  },
  dropdownBtn: {
    margin: 0,
    marginRight: "10px !important",
    padding: 0,
    backgroundColor: "#962013",
    padding: "0px 14px",
    display: "inline-block",
    '&:hover': {
      color: "unset",
      backgroundColor: "unset"
    },
    "&.active": {
      background:'#962013',
    },
    '& .MuiSvgIcon-root': {
      height: "40px",
      verticalAlign: "middle"
    },
  },
  menu: {
    '& .MuiPaper-root': {
      top: "0px !important",
      borderRadius: 0,
      [theme.breakpoints.down('xs')]: {
        width: "104%",
        maxWidth: "none",
        position: "absolute",
        left: "0px !important",
        top: "50px !important"
      },
    },
    '& .MuiList-root': {
      backgroundColor: "#962013",
    },
  },
  menuFirstItem: {
    backgroundColor: "#962013",
    color: "#FFFFFF",
    fontSize: "14px",
    [theme.breakpoints.down('xs')]: {
      display: "inline-flex",
      float: "left",
      width: "60%"
    },
    '&:focus': {
      backgroundColor: "#962013",
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
  menuItem: {
    backgroundColor: "#962013",
    color: "#FFFFFF",
    fontSize: "14px",
    paddingTop: "15px",
    paddingBottom: "15px",
    [theme.breakpoints.down('xs')]: {
      paddingLeft: "10px",
      paddingRight: "7px",
      display: "inline-flex",
    },
    '&:focus': {
      backgroundColor: "#962013",
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
  left: {
    whiteSpace: "nowrap",
    '& > $item': {
      marginRight: "20px",
    },
  },
  right: {
    whiteSpace: "nowrap",
    textAlign: "right",
    '& > $item': {
      marginRight: "5px",
      '&:last-child': {
        marginRight: "10px",
      },
    },
  },

}));

function Header(props) {
  const { toLogout } = props;
  const { t, i18n } = useTranslation("header")
  const classes = useStylesAll();
  const location = useLocation();
  const history = useHistory();
  const [cookies, setCookie, removeCookie] = useCookies();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handleClose(toPage){
    if(typeof toPage === 'string' || toPage instanceof String){
      const path = location.pathname.split('/');
      const to = '/' + path[1] + '/' + toPage;
      history.push(to);
    }
    setAnchorEl(null);
  }

  function changeLanguage(lang) {
    i18n.changeLanguage(lang)
    history.push(location.pathname.replace(/\/(tc|en)\//g, '/'+lang+'/'));
  }

  function logout() {
    setAnchorEl(null);
    // wait until dropdown is closed
    setTimeout(function() { 
      removeCookie('token', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
      removeCookie('firstName', { path: '/' });
      removeCookie('lastName', { path: '/' });
      removeCookie('expiryDate', { path: '/' });
      removeCookie('profileIcon', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
      history.push("/"+i18n.language+"/login");
    }, 50)
  }

  function logoutOnly() {
    setAnchorEl(null);
    // wait until dropdown is closed
    setTimeout(function() { 
      removeCookie('token', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
      removeCookie('firstName', { path: '/' });
      removeCookie('lastName', { path: '/' });
      removeCookie('expiryDate', { path: '/' });
      removeCookie('profileIcon', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
    }, 50)
  }

  useEffect(() => {
    if(toLogout){
      logoutOnly();
    }
  }, [toLogout])


  return (
    <>
      <Container>
          <Grid container spacing={2}>
            <Grid className={classes.left} item xs={7} md={9} >
              <Link className={classes.item} to={`/${i18n.language}`}><img src="/images/hkiff_logo.png" alt="Cinefan HK" className={classes.logo} /></Link>
              <a className={classes.item} target="_blank" href="https://hkiff.org.hk">HKIFF</a>
              <a className={classes.item} target="_blank" href="https://cinefan.hkiff.org.hk">CINE FAN</a>
            </Grid>
            <Grid className={classes.right} item xs={5} md={3}>
              { (cookies.firstName != null && cookies.lastName != null) &&
              <>
                <Button className={`${classes.item} ${classes.dropdownBtn} ${Boolean(anchorEl) ? 'active' : ''}`} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                  <Hidden xsDown>{t('hi')} {cookies.firstName} <ExpandMoreIcon/></Hidden>
                  <Hidden smUp>{Boolean(anchorEl) ? <CloseIcon/> : <PersonIcon/>}</Hidden>
                </Button>
                
              </>
              }
              <Menu
                  id="simple-menu"
                  className={classes.menu}
                  elevation={0}
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                <MenuItem className={classes.menuFirstItem} onClick={() => {handleClose()}} style={{}}>
                  {t('hi')} {cookies.firstName} <Hidden xsDown><ExpandMoreIcon/></Hidden>
                </MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => {handleClose('profile')}}>{t('profile')}</MenuItem>
                <MenuItem className={classes.menuItem} onClick={() => {logout()}}>{t('logout')}</MenuItem>
              </Menu>
              <span className={classes.item} value="en" onClick={() => {changeLanguage('en')}}>Eng</span>
              <span className={classes.item}>|</span>
              <span className={classes.item} value="tc" onClick={() => {changeLanguage('tc')}}>中文</span>
            </Grid>
          </Grid>
        </Container>
    </>
  );
}

export default Header;
